import React, { PropsWithChildren } from "react";
import { Display, LayoutContainer } from "./style";
import { TopNav } from "./TopNav ";
import { SideNav } from "./SideNav";
import { Footer } from "./Footer";

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <LayoutContainer>
      <SideNav />
      <TopNav />
      <Display>
        {children}
        <Footer />
      </Display>
    </LayoutContainer>
  );
};

export default Layout;
